import { batchMenus } from "Application/data/sidebar.data.js";

const ScrapAuthorizations = () => import("Modules/manufacturing/scrap_authorizations/views/ScrapAuthorizations");
const ScrapAuthorizationsForm = () => import("Modules/manufacturing/scrap_authorizations/views/ScrapAuthorizationsForm");

export default {
    children: [
        {
            path: "scrap_authorizations",
            name: "scrap_authorizations",
            component: ScrapAuthorizations,
            meta: {
                requiresAuth: true,
                title: "lang.scrap_authorizations",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["scrap_authorizations.read"],
                menu: batchMenus,
            },
        },
        {
            path: "scrap_authorization/:id?",
            name: "scrap_authorization",
            component: ScrapAuthorizationsForm,
            meta: {
                requiresAuth: true,
                title: "lang.scrap_authorizations",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["scrap_authorizations.read"],
                menu: batchMenus,
            },
        },
    ],
};
